export const tr = {
  brand: "Meme Meydanı",
  kicker: "KAHKAHA KAPIŞMASI",
  headlineA: "Mizahını",
  headlineB: "meydana çıkar.",
  subtitle: "Arkadaşlarını topla, en absürt cümleyi yaz ve gecenin meme efsanesi ol.",
  playerName: "Oyuncu adın",
  roomCode: "Lobi kodu",
  create: "Oyun Oluştur",
  join: "Lobiye Katıl",
  randomName: "Bana isim bul",
  howTitle: "Üç adımda meydan senin",
  steps: [
    ["01", "Ekibi topla", "Beş haneli kodu paylaş; üyelik yok, beklemek yok."],
    ["02", "Memeni patlat", "Görsele en komik cümleni yaz, süre dolmadan gönder."],
    ["03", "Tahtı kap", "Oylar sayılsın, konfeti yağsın, efsane belli olsun."]
  ],
  connection: "Canlı bağlantı",
  invalidName: "Oyuncu adı 2–18 karakter olmalı.",
  invalidCode: "Lobi kodu 5 karakter olmalı.",
  createTitle: "Meydanı kur",
  rounds: "Tur sayısı",
  captionTime: "Yazma süresi",
  players: "Oyuncu sınırı",
  back: "Geri dön",
  continue: "Lobiyi oluştur",
  waiting: "Takım toplanıyor",
  copy: "Kodu kopyala",
  invite: "Daveti kopyala",
  ready: "Hazırım",
  notReady: "Hazır değilim",
  start: "Oyunu Başlat",
  privacy: "Gizlilik",
  terms: "Kullanım Şartları"
} as const;
